module.exports = __webpack_public_path__ + "img/1466860865.fc4b3ead.jpg";